import React, { useState } from 'react';
import Modal from './Modal';
import Button from './Button';
import Input from './Input';

const PromptModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Digite a informação',
  message = '',
  placeholder = '',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  type = 'text', // text, textarea
  required = false,
  icon
}) => {
  const [value, setValue] = useState('');

  const handleConfirm = () => {
    if (required && !value.trim()) {
      return;
    }
    onConfirm(value);
    onClose();
    setValue(''); // Reset value
  };

  const handleClose = () => {
    onClose();
    setValue(''); // Reset value
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && type !== 'textarea') {
      handleConfirm();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={title} size="sm">
      <div className="space-y-4">
        {/* Icon and Message */}
        {(icon || message) && (
          <div className="text-center">
            {icon && (
              <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blue-100 mb-3">
                <span className="text-2xl text-blue-600">{icon}</span>
              </div>
            )}
            {message && (
              <p className="text-gray-700 mb-4">{message}</p>
            )}
          </div>
        )}

        {/* Input */}
        <div>
          {type === 'textarea' ? (
            <textarea
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder={placeholder}
              required={required}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 resize-none"
              rows={4}
              autoFocus
            />
          ) : (
            <Input
              type={type}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder={placeholder}
              required={required}
              onKeyPress={handleKeyPress}
              autoFocus
            />
          )}
        </div>

        {/* Buttons */}
        <div className="flex gap-3 justify-end">
          <Button
            onClick={handleClose}
            variant="secondary"
            size="sm"
          >
            {cancelText}
          </Button>
          <Button
            onClick={handleConfirm}
            variant="primary"
            size="sm"
            disabled={required && !value.trim()}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PromptModal;